import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from 'react-router-dom';
// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./Brandfocus.css";
import focus_data1 from "./BfocusData1";
import focus_data2 from "./BfocusData1_2";
import focus_data3 from "./BfocusData2";
import focus_data4 from "./BfocusData2_2";
import focus_data5 from "./BfocusData3";
import focus_data6 from "./BfocusData3_2";


function Brandfocus() {
    const [bfdata1] = useState(focus_data1);
    const [bfdata2] = useState(focus_data2);
    const [bfdata3] = useState(focus_data3);
    const [bfdata4] = useState(focus_data4);
    const [bfdata5] = useState(focus_data5);
    const [bfdata6] = useState(focus_data6);


    let [res2, setRes2] = useState([34, 35, 36, 37, 38, 39]);
    let [res4, setRes4] = useState([42, 43, 44, 45, 46, 47]);
    let [res6, setRes6] = useState([50, 51, 52, 53, 54, 55]);


    return (
        <>
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                className="mySwiper3"
            >
                <SwiperSlide>
                    <Bfocusbox1 bfdata1={bfdata1} bfdata2={bfdata2}  res2={res2}/>
                </SwiperSlide>
                <SwiperSlide>
                    <Bfocusbox2 bfdata3={bfdata3} bfdata4={bfdata4}  res4={res4}/>
                </SwiperSlide>
                <SwiperSlide>
                    <Bfocusbox3 bfdata5={bfdata5} bfdata6={bfdata6} res6={res6}/>
                </SwiperSlide>
            </Swiper>
        </>
    );
}



function Bfocusbox1(props) {
    return (
        <>
            {
                props.bfdata1.map((a, i) => {
                    return (
                        <div className="bfBox_top">
                            <img src={a.imgurl} />
                        </div>
                    )
                })
            }
            {
                props.bfdata2.map((a, i) => {
                    return (
                        <div className="bfBox_bottom">
                            <Link to={`/detail/${props.res2[i]}`}>
                            <img src={a.imgurl} />
                            <div className="bfBox_txt">
                                <h6>{a.brand}</h6>
                                <p>{a.title}</p>
                                <span>{a.persent}</span><span>{a.price}</span>
                            </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )
}


function Bfocusbox2(props) {
    return (
        <>
            {
                props.bfdata3.map((a, i) => {
                    return (
                        <div className="bfBox_top">
                            <img src={a.imgurl} />
                        </div>
                    )
                })
            }
            {
                props.bfdata4.map((a, i) => {
                    return (
                        <div className="bfBox_bottom">
                            <Link to={`/detail/${props.res4[i]}`}>
                            <img src={a.imgurl} />
                            <div className="bfBox_txt">
                                <h6>{a.brand}</h6>
                                <p>{a.title}</p>
                                <span>{a.persent}</span><span>{a.price}</span>
                            </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )
}


function Bfocusbox3(props) {
    return (
        <>
            {
                props.bfdata5.map((a, i) => {
                    return (
                        <div className="bfBox_top">
                            <img src={a.imgurl} />
                        </div>
                    )
                })
            }
            {
                props.bfdata6.map((a, i) => {
                    return (
                        <div className="bfBox_bottom">
                            <Link to={`/detail/${props.res6[i]}`}>
                            <img src={a.imgurl} />
                            <div className="bfBox_txt">
                                <h6>{a.brand}</h6>
                                <p>{a.title}</p>
                                <span>{a.persent}</span><span>{a.price}</span>
                            </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )
}

export default Brandfocus;
